import Container from "../Container";
import ReactMarkdown from "react-markdown";
import ChallengeSudoku from "../ChallengeSudoku";
import * as Props from "@/types/PropTypes";
import { AdsMobileBannerWrapper, ContentWrapper } from "./DailySudoku.components";
import AdsMobileBanner from "../AdsMobileBanner";

function DailySudoku({ content }: Props.Content) {
  return (
    <>
      <AdsMobileBannerWrapper>
        <AdsMobileBanner />
      </AdsMobileBannerWrapper>

      <Container>
        <ChallengeSudoku />

        <ContentWrapper>
          <ReactMarkdown>{content}</ReactMarkdown>
        </ContentWrapper>
      </Container>
    </>
  );
}
export default DailySudoku;
